export default __webpack_public_path__ + "static/media/title-cn.a9aa636e.webp";